import * as React from 'react';
import { format, isSameMonth, isToday } from 'date-fns';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import { DayItem } from '../../../interfaces';
import { cx } from '../../../helpers/global';

type Props = {
  day: DayItem;
  selectedMonth: Date;
  selectedDay?: Date;
  setSelectedDay: React.Dispatch<React.SetStateAction<Date>>;
  setDayIsSelected: React.Dispatch<React.SetStateAction<boolean>>;
  disableUnavailable?: boolean;
};

export default function Day({
  day,
  selectedMonth,
  selectedDay,
  setSelectedDay,
  setDayIsSelected,
  disableUnavailable = false,
}: Props) {
  let date: Date;

  if (day.date.length === 10) {
    date = new Date(`${day.date}T00:00:00`);
  } else {
    date = new Date(day.date);
  }

  const sameMonth = isSameMonth(date, selectedMonth);
  const isSelected =
    !!selectedDay &&
    format(selectedDay, 'yyyy-MM-dd') === format(date, 'yyyy-MM-dd');
  const dayFormat = 'd';

  function setDay(pickedDay: Date) {
    setSelectedDay(pickedDay);
    setDayIsSelected(true);
  }

  if (!sameMonth) {
    return (
      <Grid item xs={1} className="day hidden">
        <span className="day-mark">
          <Typography variant="body1">{format(date, dayFormat)}</Typography>
        </span>
      </Grid>
    );
  }

  const isAvailable = !!day.available;
  const onClick =
    !isAvailable && disableUnavailable ? undefined : () => setDay(date);

  return (
    <Grid
      item
      xs={1}
      className={cx('day', isAvailable && 'available')}
      onClick={onClick}>
      <span
        className={cx(
          'day-mark',
          isSelected && 'selected',
          isToday(date) && 'today',
        )}>
        <Typography variant="body1">{format(date, dayFormat)}</Typography>
      </span>
    </Grid>
  );
}
